export const SET_DETAILS_LICENSES = 'SET_DETAILS_LICENSES';
export const SET_DETAILS_CLIENTS = 'SET_CLIENT_DETAILS_CLIENTS';
export const SET_DETAILS_ERROR_LICENSES = 'SET_DETAILS_ERROR_LICENSES';
export const SET_PAGINATION_PAGE_CLIENTS = 'SET_PAGINATION_PAGE_CLIENTS';
export const SET_PAGINATION_SIZEPERPAGE_CLIENTS = 'SET_PAGINATION_SIZEPERPAGE_CLIENTS';
export const SET_DETAILS_ERROR_CLIENTS = 'SET_DETAILS_ERROR_CLIENTS';
export const SET_DETAILS_CLIENTS_HEALTHSCORE = 'SET_DETAILS_CLIENTS_HEALTHSCORE';